import { render, staticRenderFns } from "./ShowMessageButton.vue?vue&type=template&id=644ed858&scoped=true&"
import script from "./ShowMessageButton.vue?vue&type=script&lang=js&"
export * from "./ShowMessageButton.vue?vue&type=script&lang=js&"
import style0 from "./ShowMessageButton.vue?vue&type=style&index=0&id=644ed858&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644ed858",
  null
  
)

export default component.exports